import React, { useState } from "react"
import StatisticCard from "components/common/statisiticCard/StatisticCard"
import { ArrowDownLeft, ArrowUpRight, DollarSign, Plus, TrendingUp } from "lucide-react"
import TransactionDataTable from "components/transactions/synthesis/TransactionDataTable"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "components/ui/dropdown-menu"
import { Button } from "components/ui/button"
import CreditClientForm from "components/clientDataTable/CreditClientForm"
import DebitClientForm from "components/clientDataTable/DebitClientForm"

const Synthese = () => {
  const [newTransactionDropdownOpen, setNewTransactionDropdownOpen] = useState(false)

  const [openDebitModal, setOpenDebitModal] = useState(false)
  const [openCreditModal, setOpenCreditModal] = useState(false)

  const [transactionStats, setTransactionStats] = useState({
    monthlyRevenue: 2450000,
    growthRate: 15.3,
    unusedBalance: 32450000,
  })

  const cardsData = [
    {
      title: "Revenu mensuel",
      total: transactionStats.monthlyRevenue,
      percentage: "18",
      icon: <DollarSign className="text-blue-800" strokeWidth={2.5} />,
      currency: "Fcfa",
    },
    {
      title: "Taux de croissance",
      total: transactionStats.growthRate,
      percentage: 2.1,
      icon: <TrendingUp className="text-blue-800" strokeWidth={2.5} />,
      isPercent: true,
    },
    {
      title: "solde total non consommé",
      total: transactionStats.unusedBalance,
      percentage: 18,
      icon: <DollarSign className="text-blue-800" strokeWidth={2.5} />,
      currency: "Fcfa",
    },
  ]

  const handleAddTransactionModalOpen = () => {
  }

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-3">
        <DropdownMenu open={newTransactionDropdownOpen} onOpenChange={setNewTransactionDropdownOpen}>
          <DropdownMenuTrigger asChild>
            <Button className="ml-auto gap-2">
              <Plus className="h-4 w-4" />
              Nouvelle Transaction
            </Button>
          </DropdownMenuTrigger>

          <DropdownMenuContent align="end" className="w-64">
            <DropdownMenuItem
              onSelect={(e) => {
                e.preventDefault()
                setOpenCreditModal(true)
                setNewTransactionDropdownOpen(false)
              }}
              className="cursor-pointer gap-2"
            >
              <ArrowDownLeft className="h-4 w-4" />
              Transaction de crédit
            </DropdownMenuItem>
            <DropdownMenuItem
              onSelect={(e) => {
                e.preventDefault()
                handleAddTransactionModalOpen()
                setOpenDebitModal(true)
                setNewTransactionDropdownOpen(false)
              }}
              className="cursor-pointer gap-2"
            >
              <ArrowUpRight className="h-4 w-4" />
              Transaction de débit
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cardsData.map((card) => (
          <StatisticCard key={card.title} {...card} />
        ))}
      </div>

      <TransactionDataTable />

      <CreditClientForm
        open={openCreditModal}
        onClose={() => setOpenCreditModal(false)}
      />
      <DebitClientForm
        open={openDebitModal}
        onClose={() => setOpenDebitModal(false)}
      />
    </div>
  )
}

export default Synthese
